
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/alerts",
      function () {
        return require("private-next-pages/components/alerts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/alerts"])
      });
    }
  